"use client";

import {
  environmentManager,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import type { ReactNode } from "react";

/**
 * Provider TanStack Query — SATU-satunya, di root layout (semua zona berbagi
 * client yang sama; sesi client TIDAK lewat cache React Query — pakai
 * nanostore authClient.useSession / refetchSession dari data/user/use-session;
 * eks cache ['session'] vestigial dihapus 2026-09-23: penulis tanpa pembaca).
 */
function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

function getQueryClient() {
  if (environmentManager.isServer()) {
    // Server: selalu client baru per request — cache tidak boleh bocor
    // antar request.
    return makeQueryClient();
  }
  // Browser: singleton — dibuat sekali dan JANGAN di-remake bila React
  // suspend saat render pertama (pola current docs TanStack Query; lama:
  // useState yang bisa dibuang React saat suspend tanpa boundary).
  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }
  return browserQueryClient;
}

export const ReactQueryClientProvider = ({ children }: { children: ReactNode }) => {
  const queryClient = getQueryClient();
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
